// extracted by mini-css-extract-plugin
export var actions = "_7-0";
export var actionsContainer = "_7-7";
export var border = "_7-1";
export var childFullHeight = "_7-g";
export var collapse = "_7-2";
export var content = "_7-b";
export var contentChild = "_7-f";
export var fullscreen = "_7-d";
export var hasLeftRadius = "_7-l";
export var headerContainer = "_7-3";
export var headerRow = "_7-5";
export var hidePadding = "_7-c";
export var navCollapsedGap = "_7-m";
export var noScrollX = "_7-n";
export var noScrollY = "_7-o";
export var noTopPadding = "_7-j";
export var optOutTopPadding = "_7-e";
export var pageMain = "_7-k";
export var pageOuter = "_7-h";
export var pagePadding = "_7-8";
export var pageScroll = "_7-9";
export var profile = "_7-p";
export var profileContainer = "_7-q";
export var profileImage = "_7-r";
export var profileMain = "_7-s";
export var profileSubtitle = "_7-u";
export var profileTitle = "_7-t";
export var settingsSurface = "_7-a";
export var showLeftPadding = "_7-i";
export var tabsPortalSlot = "_7-6";
export var tabsWrapper = "_7-4";
export var title = "_7-v";